export type FaqItem = {
  question: string;
  answer: string;
};

export const faqs: FaqItem[] = [
  {
    question: "瓜田观察站的内容从哪里来？",
    answer:
      "站内整理均基于公开渠道发布的信息，例如账号公告、平台说明与媒体报道。我们只做梳理与归纳，不添加任何未经证实的内容，也不会使用非公开材料。",
  },
  {
    question: "事件档案为什么要按时间线整理？",
    answer:
      "热点讨论的信息往往分散在不同时间点，按时间线排列能看清哪一步先发生、哪一步是回应，减少把后出现的说法当成起因的误判。",
  },
  {
    question: "档案里的「已回应」「已归档」「持续跟进」是什么意思？",
    answer:
      "「持续跟进」表示还有新的公开信息可能出现；「已回应」表示相关方已发布说明；「已归档」表示当前没有新的公开进展，内容进入整理完成状态，后续如有更新会重新标注。",
  },
  {
    question: "站内会出现个人隐私信息吗？",
    answer:
      "不会。我们对涉及个人身份、联系方式、账号凭证的内容一律不呈现，也会对可识别的细节做模糊处理。围观可以，越界不行，这是我们最坚持的一条。",
  },
  {
    question: "可以投稿线索或纠正内容吗？",
    answer:
      "可以。你可以在「关于我们」页面通过联系表单提交线索或纠正请求，请尽量附上公开来源链接，方便我们核对。我们会在核实后更新档案。",
  },
  {
    question: "档案更新后会通知吗？",
    answer:
      "我们会在事件详情页标注最后更新时间。你也可以通过订阅表单留下邮箱，重要事件有新增公开进展时，我们会整理成简报发送。",
  },
];